import { TabType } from './schema/TabViewState';
import { createStore } from 'satcheljs';
var primaryTabInitialState = {
    id: 'primaryTab',
    type: TabType.Primary,
    isShown: true,
    isActive: true,
    blink: false,
};
var tabStoreData = {
    tabs: [primaryTabInitialState],
    availableTabSlotCount: 2,
    isOverflowMenuShown: false,
};
export var getStore = createStore('tab', tabStoreData);
var tabStore = getStore();
export default tabStore;
// Export the reference from the store (http://aka.ms/mobx4)
export var primaryTab = getStore().tabs[0];
//# sourceMappingURL=tabStore.js.map